module.exports = {
	"data": {
		"postBySlug": {
			"html": "<h2 id=\"load-the-shapefile-into-postgis\"><a href=\"#load-the-shapefile-into-postgis\" aria-hidden=\"true\" class=\"anchor\"><svg aria-hidden=\"true\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg></a>Load the shapefile into PostGIS</h2>\n<p>The first thing to do is to add the dataset <code>mnz_italy</code> to our PostGIS database <code>caaml_data</code>. QGIS is the quick way to go. Let's go through the screenshot below after having extracted the shapefile from the archive in the folder <code>data</code>.</p>\n<h4 id=\"add-the-shapefile-to-qgis\"><a href=\"#add-the-shapefile-to-qgis\" aria-hidden=\"true\" class=\"anchor\"><svg aria-hidden=\"true\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg></a>Add the shapefile to QGIS</h4>\n<p>\n  <a\n    class=\"gatsby-resp-image-link\"\n    href=\"undefined\"\n    style=\"display: block\"\n    target=\"_blank\"\n    rel=\"noopener\"\n  >\n  \n  <span\n    class=\"gatsby-resp-image-wrapper\"\n    style=\"position: relative; z-index: -1; display: block; \"\n  >\n    <span\n      class=\"gatsby-resp-image-background-image\"\n      style=\"padding-bottom: 62.5%;position: relative; width: 100%; bottom: 0; left: 0; background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAAAsSAAALEgHS3X78AAAC8ElEQVQ4y12Se2/aZhTG/Vkn7eNMWqRmY6UJaSK6tGuaNr2ol2lRmoY7NjbYxhAwwWDul5iGQMj227HX/dNXOjqv5NfPeS5HyX36QObPU7J/XVA8S0X3xAufo2Ob5ycN9l/avHhb5/hdjTefLF5/KBM/VNl9rvPqvUouleXL+TmZ1BlpuSuOpWEYKqapYVYMypqK22rTaLhcXXkMR2NG4ymLxQ1ZzaaoWVhOi25vimZUKBTzZEsZckUptYRSKJySznymrGuouXNyuQLDwYD5fC4gAXd3d1GtVysMqyaDTSmL6+uAWr1Gu32FaZkUiwVUVUNJ57PoaopyKYshXVczAugzm4WsFqzXd9zf/81ms6FsOViWJewbAnhNp+ujl006fp/eYBgNUXJFlYpQrmjp/3opTd/36PV6jETucnkrtWI8mZEXSYVCUSwycF03euN5HYZiCfxDeIRhIQIrh4Dfer8nj4ZDYTljJVLX6zX9wYSWeNputwXEo9vtysARk8kE1xtQb0+58mcoF9kiupajYnzrepHRsB9JWt7eRmCb+w0DYRuC/F/T6ZTxeBwBGk6Hk8+XpAwfRdUNajUn8qXmVKM+Gg2ZjCfMg4B5CLy6FQYt8iUDXbckFEdY9uh2BqJkhlH1eHtWIVduo5jVavRTyChMNhBjw6mdTge/58vaDLlZfqXaNLnIH0qaR+jGCZb9Dqf+UVbslIarUa7YNJsuil2r8/0JgUOmzWZdwIci+0YCqFM2t9H0LUn2AaYdw3Z+o1qL4/lfsFyfhniphH58f4JggeM4VKsOA1mH5XIp0kbYdkPWpi7fXFotH98PQwlQmwseXQTs5W5QLi+bXAtAEHwV2YtI8nw2iVL2vLYk28IT+f1+X2zwolUKPR6PR4wl5XATjtN9ftwL+CEpKcd3jtjbf0nyyXt2Eq/Yf3zAmz92efb0KU8O4iQOdtjajpFMJnn2+x4P4rv8GvuZnUdbHMRiJB4+JPbLTxwm5O32Fv8C9VaW9tor+v8AAAAASUVORK5CYII='); background-size: cover; display: block;\"\n    >\n      <img\n        class=\"gatsby-resp-image-image\"\n        style=\"width: 100%; margin: 0; vertical-align: middle; position: absolute; top: 0; left: 0; box-shadow: inset 0px 0px 0px 400px white;\"\n        alt=\"add shape qgis\"\n        title=\"\"\n        src=\"/static/7c535e549e8a2be33d7fb96fbb99f5f5-44d6a.png\"\n        srcset=\"/static/7c535e549e8a2be33d7fb96fbb99f5f5-f4799.png 173w,\n/static/7c535e549e8a2be33d7fb96fbb99f5f5-b3b1d.png 345w,\n/static/7c535e549e8a2be33d7fb96fbb99f5f5-44d6a.png 690w,\n/static/7c535e549e8a2be33d7fb96fbb99f5f5-bc0f7.png 1035w,\n/static/7c535e549e8a2be33d7fb96fbb99f5f5-b50e5.png 1380w,\n/static/7c535e549e8a2be33d7fb96fbb99f5f5-0ed32.png 2070w,\n/static/7c535e549e8a2be33d7fb96fbb99f5f5-55f2e.png 2560w\"\n        sizes=\"(max-width: 690px) 100vw, 690px\"\n      />\n    </span>\n  </span>\n  \n  </a>\n    </p>\n<p>We should see something like this:</p>\n<p>\n  <a\n    class=\"gatsby-resp-image-link\"\n    href=\"undefined\"\n    style=\"display: block\"\n    target=\"_blank\"\n    rel=\"noopener\"\n  >\n  \n  <span\n    class=\"gatsby-resp-image-wrapper\"\n    style=\"position: relative; z-index: -1; display: block; \"\n  >\n    <span\n      class=\"gatsby-resp-image-background-image\"\n      style=\"padding-bottom: 56.05942142298671%;position: relative; width: 100%; bottom: 0; left: 0; background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsSAAALEgHS3X78AAAB9UlEQVQoz4WSzW7TQBSF/WiAeArEMyDxArBnywaeAAm6oUVFQqhRldax69+ZjN0EZ5E/OTH5sY1C2ySUj3FEilJF4khHHp07c+7RvTZiaROGDn7o02wKHMdCSoFSCj9wtCYJQoHvO3giIpSKpnSImrb+BgROgBCSOPJoXPgYStSwnbo2CJGBie9KbDfG8iNs7xTHNTlpNEjkBa3Lylzhqja2L3WzOqFwsUMLV/o6QIBx4bo41hlSpww9G88xUdIjVoL1en1Hf+bxvPOMVnm5o1ecTCZ4QUir1cKwXQ+lO9xn3PTY4vb3LZ+yQ56WT8hWGfexWq3uzsaZ5fzXcIu3P9/wOH9Eb93b0ZfLJTd/abg6alQN+R5bUcA+nN6c8nDxgGD5r55mcw6+XnKmcgzL9fWWQ+I4RujtRlFMv9+n1+vtNSx/lXxYvKe4Le600aTg3XHAF6uLce7FfA461MV3Ds2UI3PEUWPMsZXuNTRX59RWtR1tNpshhaDd/obRTpK9D6tBDwYDsiyj2+2SpunmXKUfjUabzW45n8/JpnPG4zFGdWEfqkFXF4bDIYlu2ukkm99iyyTpbGqVmeoXvK5f8erkCqPbHVGW1xTFNblmWf7QLJlOp5s01aMqUZ7nm8QzbVDVi6JgsVgwnc0xVcrLg5wXH6f8AR3MHYn/2PiHAAAAAElFTkSuQmCC'); background-size: cover; display: block;\"\n    >\n      <img\n        class=\"gatsby-resp-image-image\"\n        style=\"width: 100%; margin: 0; vertical-align: middle; position: absolute; top: 0; left: 0; box-shadow: inset 0px 0px 0px 400px white;\"\n        alt=\"view shape qgis\"\n        title=\"\"\n        src=\"/static/ad98833ac4b23676d21bfc1e3e8c63f6-44d6a.png\"\n        srcset=\"/static/ad98833ac4b23676d21bfc1e3e8c63f6-f4799.png 173w,\n/static/ad98833ac4b23676d21bfc1e3e8c63f6-b3b1d.png 345w,\n/static/ad98833ac4b23676d21bfc1e3e8c63f6-44d6a.png 690w,\n/static/ad98833ac4b23676d21bfc1e3e8c63f6-bc0f7.png 1035w,\n/static/ad98833ac4b23676d21bfc1e3e8c63f6-b50e5.png 1380w,\n/static/ad98833ac4b23676d21bfc1e3e8c63f6-0ed32.png 2070w,\n/static/ad98833ac4b23676d21bfc1e3e8c63f6-fa8e7.png 2558w\"\n        sizes=\"(max-width: 690px) 100vw, 690px\"\n      />\n    </span>\n  </span>\n  \n  </a>\n    </p>\n<h4 id=\"create-a-new-postgis-connection-for-caaml_data\"><a href=\"#create-a-new-postgis-connection-for-caaml_data\" aria-hidden=\"true\" class=\"anchor\"><svg aria-hidden=\"true\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg></a>Create a new PostGIS connection for caaml_data</h4>\n<p>\n  <a\n    class=\"gatsby-resp-image-link\"\n    href=\"undefined\"\n    style=\"display: block\"\n    target=\"_blank\"\n    rel=\"noopener\"\n  >\n  \n  <span\n    class=\"gatsby-resp-image-wrapper\"\n    style=\"position: relative; z-index: -1; display: block; \"\n  >\n    <span\n      class=\"gatsby-resp-image-background-image\"\n      style=\"padding-bottom: 62.5%;position: relative; width: 100%; bottom: 0; left: 0; background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAAAsSAAALEgHS3X78AAAC+ElEQVQ4y2WTWW/bRhRG+VsL9L0v/Qd9LNAiqFMnXmS7dlsgiZ0GCBLBSQzbWihaoiRqoRaSEq2dlESJim1Z2+mQ6QK0FxjcGXDm3G/ufJSU8yjyhwtSn+JkLhPhPHLa5dWZzss3JkevdU7f1ol+rKFrWbSMzM1Nmnw+hyynSMVlYtfXyIlLkokUUrUkNmlpCkWVQiGHpqqYlo2uV2k0bBx3iDsc44zueHFu8cenJueyQ1SeEI3VBFwhlUuiiEKKmkNKpy+IxS/QciqqckUimabT6dLr9RiNhiyXS5arJff3D6QLVfKaTr6gMxz5VOsW/X6fSrVCJpNGVbNISSVFNh1Dy8pCXYK8KjPotULgeOyx2WwIYv54j1YuU6vUhHKL2czn4eGB1Wol5jN6A4fp1EdSMirFbJKCGMWcLEaSVtPEMOq0Wu1w83w+Z/Z5RiwXJZk9xzZ7OAM3BAaxFlD4UlhKigb/A/wrN6065XKJZrPJZDIR173HF4pabpVX+jdEze9wpnbYjiCGY5/67Ri76yEllAylfJqKeJSydhNmu2lgmgau63J3dxdeK8gbVtRn73nX+ZbZYsDfYdgD3lwZJLSuAKbzfEyqxG4qvL/S+JDQqZlN6sYXoOdNwj4+Pj6Gh0dzC9U9ZrVe/AtsdHl7WUQp3Ioe5soo+i3Zqst1vk9cc2i0+tTqBu12O4QuhcKgX+v1GsO7xJ4qYr4J14F6x3GF7XQsq4FUEQf/G/50SsOywh56nsdisQjBjuMIBwwZup6w1Cj8NhV7xxOfslBptgZInU7n/0B/RrVapVKpMBB2CB5lIGClUolisShMH6ixwhs4olDG9NiN+xwod0iGYTEVAN//LKqJLLzkjUcC1Kd1a2PbNm1RNDBwp90SSsWf4zoMhy5DUSRQeZrs8/WBz1cn4pV39l4SOTzj5OQde/uvOTr8hbNft9nf2+X4YJvI0S5Pnj7j5PiYF78dsLWzz89PfyCy94TIT1sc7jxje+t7fo88F+sf+ROpXZw3yjgdkwAAAABJRU5ErkJggg=='); background-size: cover; display: block;\"\n    >\n      <img\n        class=\"gatsby-resp-image-image\"\n        style=\"width: 100%; margin: 0; vertical-align: middle; position: absolute; top: 0; left: 0; box-shadow: inset 0px 0px 0px 400px white;\"\n        alt=\"open connection qgis\"\n        title=\"\"\n        src=\"/static/b8017f72b83befc57c1695d1d90f89f6-44d6a.png\"\n        srcset=\"/static/b8017f72b83befc57c1695d1d90f89f6-f4799.png 173w,\n/static/b8017f72b83befc57c1695d1d90f89f6-b3b1d.png 345w,\n/static/b8017f72b83befc57c1695d1d90f89f6-44d6a.png 690w,\n/static/b8017f72b83befc57c1695d1d90f89f6-bc0f7.png 1035w,\n/static/b8017f72b83befc57c1695d1d90f89f6-b50e5.png 1380w,\n/static/b8017f72b83befc57c1695d1d90f89f6-0ed32.png 2070w,\n/static/b8017f72b83befc57c1695d1d90f89f6-55f2e.png 2560w\"\n        sizes=\"(max-width: 690px) 100vw, 690px\"\n      />\n    </span>\n  </span>\n  \n  </a>\n    </p>\n<p>Click on <code>new</code> for create a new connection</p>\n<p>\n  <a\n    class=\"gatsby-resp-image-link\"\n    href=\"undefined\"\n    style=\"display: block\"\n    target=\"_blank\"\n    rel=\"noopener\"\n  >\n  \n  <span\n    class=\"gatsby-resp-image-wrapper\"\n    style=\"position: relative; z-index: -1; display: block; \"\n  >\n    <span\n      class=\"gatsby-resp-image-background-image\"\n      style=\"padding-bottom: 138.47874720357942%;position: relative; width: 100%; bottom: 0; left: 0; background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAcCAYAAABh2p9gAAAACXBIWXMAAAsSAAALEgHS3X78AAAC9ElEQVRIx+VV2VbaUBTl//+kLypddSGIQOaBMIQhJBJIwiCDlaXLvu+ec0Cq1iH2tQ+bXC737uwzbQru9yIs00LVOIfruoJa7QrVK0K1ikqlfHheolIuo3xAqVSiZwXNZhNNdw++W1jMZ1A1DZZlQdN1tFseNE2nl+gwDQNO08Nms8mNQpYm8FotRNfXWC6XmM1miKIIYRgKdrtdbszncxT4YxzHmE6nR0Je39zc0DrD7e1tbvDdAl+yHRu2bWOxWMjmV0j+IkzTlPJlIEmzo8Jup4PBMEC328VwMEAQRnh8fPwUEnJKOeSCXB9ymGUZuu02vWCGh4eHL+EYcocI2lSY8Xgsmx1SGFFBXErFer3G/f19LohCJhwOhwKuKiucTCaIRgHCiFRTcfLkb7VaHQizFLpuUIO68DwPvt9DsVjE2dkpTk5OqaEr0th8OEmmUrjskG9eP4GFSMh8kPvuCb7vQ1EUaW5NVellupByjl3XgW6YlApnn5Zn9xhJktCkEDv33XN0gxidYJwLwyiWFPE97hghVFVFwtZoBFlVzfZheD5018d69+tDmP0U55cKzX/tD+FrhVxtDjEP4sOUvVCokcJGo0EmocsP0eHwnJL8WTMPoil+VD5R+K8QQi7/e1Y0I2vj8DksVsyV5K5477z0ISvkKkk+6PLetkZCwmuXjJOnyLJMOGSg/AK++BakD5nQ77ShqBoa9Roql1XKR53MVae8Kri4uJCnpqko0Zr71Pc76NIAsHm0aWxNcnz2g2MfDvp9cmtNLtXqDdTrdXFrJjNov0bfPZqkavWKrM6hiGJRmnABKQ0cIZMdFfZ7PZmMFo2eZTtw6BIbA+9xmI5twbTIMylsk5RMJnszfg3mEsKAjIHn2KM/HG4dVmMRARObukqqXBnHwaD/JtELQnaJjw59Bf8rIbvtdrsVcLc/rd/D8zO8Xq42SOZbQbbYosCbPjVoOArl0N3d3YfgM3E8Rkv+g2KMkhXOe2t80wM0wp/4DaNU2JkNi0TwAAAAAElFTkSuQmCC'); background-size: cover; display: block;\"\n    >\n      <img\n        class=\"gatsby-resp-image-image\"\n        style=\"width: 100%; margin: 0; vertical-align: middle; position: absolute; top: 0; left: 0; box-shadow: inset 0px 0px 0px 400px white;\"\n        alt=\"add connection qgis\"\n        title=\"\"\n        src=\"/static/8d1f8fe82cf4a13c9881e4bd0cd65f48-44d6a.png\"\n        srcset=\"/static/8d1f8fe82cf4a13c9881e4bd0cd65f48-f4799.png 173w,\n/static/8d1f8fe82cf4a13c9881e4bd0cd65f48-b3b1d.png 345w,\n/static/8d1f8fe82cf4a13c9881e4bd0cd65f48-44d6a.png 690w,\n/static/8d1f8fe82cf4a13c9881e4bd0cd65f48-cf5ec.png 894w\"\n        sizes=\"(max-width: 690px) 100vw, 690px\"\n      />\n    </span>\n  </span>\n  \n  </a>\n    </p>\n<p>Fill the fields with the same connection parameters used for <strong>PGAdmin4</strong></p>\n<p>\n  <a\n    class=\"gatsby-resp-image-link\"\n    href=\"undefined\"\n    style=\"display: block\"\n    target=\"_blank\"\n    rel=\"noopener\"\n  >\n  \n  <span\n    class=\"gatsby-resp-image-wrapper\"\n    style=\"position: relative; z-index: -1; display: block; \"\n  >\n    <span\n      class=\"gatsby-resp-image-background-image\"\n      style=\"padding-bottom: 84.64163822525597%;position: relative; width: 100%; bottom: 0; left: 0; background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAARCAYAAADdRIy+AAAACXBIWXMAAAsSAAALEgHS3X78AAABqklEQVQ4y+2USW/bQAyF5///lN566yFoUSNyDDlarNEaW6o0o83a0kNlpQmQF44AB2rRpkDrYw8fSJBPxBMwJDM+fcRn7Qq6rsM0TXDOX9lsNtA0Dev1GqvVCtr19Yxh/KhbwoTI4HkeuMORpinquv5ryrIEy/OCHBpYbzmCg0RVVXPzHJVI5cv6kqVWGWIyz/Feu8O7KwMf9AOiKMRut4OUEg5FyzKRZRl834fjOBBCoCgK6gvY1E+SZP4mDEPkNIvxuMA2kDD2FcxDDXtf4O6LRCwqZGX7Bg32aT7rElkjzkrK6ZftpIG5L+HXJ0TtI5L2BCFzdN2A8TT9nnEipyVpC/T9gH64R5SQw2oYcfr+fBHq+wms7Ed8e3i+CNXwf+BFBqb0ppr2babpAY9PT3+k/TqCZcURm1sbhhPgdudR9HGztWB7Eba2C93isNwIoqLHXDTg4QEmaec6V9GlfogbmsHDGOx4PMJ1vXmtAj+gnI4ErVrf92jJnYpnuq57ZVk/o/TsV41/galr4roulFN1BOI4Rk7Lr66HWnyFqv/sdknTNPMMdTheAMxD9q5vqBBSAAAAAElFTkSuQmCC'); background-size: cover; display: block;\"\n    >\n      <img\n        class=\"gatsby-resp-image-image\"\n        style=\"width: 100%; margin: 0; vertical-align: middle; position: absolute; top: 0; left: 0; box-shadow: inset 0px 0px 0px 400px white;\"\n        alt=\"postgis connect qgis\"\n        title=\"\"\n        src=\"/static/1cc75207858502b1c2bbb1d182fecdbc-44d6a.png\"\n        srcset=\"/static/1cc75207858502b1c2bbb1d182fecdbc-f4799.png 173w,\n/static/1cc75207858502b1c2bbb1d182fecdbc-b3b1d.png 345w,\n/static/1cc75207858502b1c2bbb1d182fecdbc-44d6a.png 690w,\n/static/1cc75207858502b1c2bbb1d182fecdbc-bc0f7.png 1035w,\n/static/1cc75207858502b1c2bbb1d182fecdbc-88848.png 1172w\"\n        sizes=\"(max-width: 690px) 100vw, 690px\"\n      />\n    </span>\n  </span>\n  \n  </a>\n    </p>\n<p>Click <code>ok</code> and then <code>connect</code>.</p>\n<h4 id=\"load-the-shapefile-into-the-connected-schema\"><a href=\"#load-the-shapefile-into-the-connected-schema\" aria-hidden=\"true\" class=\"anchor\"><svg aria-hidden=\"true\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg></a>Load the shapefile into the connected schema</h4>\n<p>\n  <a\n    class=\"gatsby-resp-image-link\"\n    href=\"undefined\"\n    style=\"display: block\"\n    target=\"_blank\"\n    rel=\"noopener\"\n  >\n  \n  <span\n    class=\"gatsby-resp-image-wrapper\"\n    style=\"position: relative; z-index: -1; display: block; \"\n  >\n    <span\n      class=\"gatsby-resp-image-background-image\"\n      style=\"padding-bottom: 62.5%;position: relative; width: 100%; bottom: 0; left: 0; background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAAAsSAAALEgHS3X78AAACxElEQVQ4y22Se2/bZBTG/c0QX2USf8AfCMHnQFDQumrtml7SrcBWrZUQLS1rkjZ27PiS2M51Wbo0d8dtiLNuy/XHGzO2AT3Wo+d9z7Ge8+g9R9KOj0idnKI+S2LE5fBsJVTMRAr5WYzYaQw1FuPwSOX7XZ9H+w7RgyJrP8ts7WX57djg/OyMlBxHkVWkUs7CtnUc18RxMtjmgl1sJ4dlnGCZMmbGIO+kMXSDhGimWHlkLYWq/S6gomYUNCOFZmaQdP2U8+QpdsbE1BLIik7asElbLrVGnZf1JuWXda5adR6Xf8K9dOh0u3Q6HYFWyMVSEcPQMU0LSREdLP0c20oJdzJZU7ClknczjCcTxuMJwdtXPGpE+ar9JRORm06n/8JwOKTd9RgMAiTNMHEtBUfAzaQElBClfIZ/YiY+IzD41P+EP25O+G/MhCjMw7OkpPUPgu/YEU6L4m0/jtFsxMGbfb4IPmfp7RLe1Htf868Dnl9eU2v1kWTNIJfVKYqh5O10yNWyQ61a+p+ThYmj8RHf3HxNZ9J+n67UuhwkKsh2SwjqWY4Vk/N0kcOEzYlc4MyokspecFtcTKtEX28zno8/CF60+DXuojmX4g0zeZRiDavU4yzbIWl7JB0PNdcNBzCbzZjP5yEvEH8dR3ujMp/9nVsMxfN6Yu0KVKsXSMXnlVudzGcT8aOH7/u02226YlXCe8un7/W5urqi3++LyQ64/jMgL1y+qHeRms3mrYKj0Uh0rFIuldF1MTjXJZfLhVwoFMJao9HA6/UwXvRZSwZsaDdIlUqVQTAkCF6JbgsOGAaD0EGn0w7hv3PTFIve6/kCC+c9fCG2yO8pHT7bCLizI6a8+uAJG1tP2Xl4yIPIPlubUfYerhBZX2d7Y4X17TV+WL7Pzk6UX3Y3ubsW4d6970T9RyJ3l9lcvc/K8rfsRlbFfYm/AOavmBZY6alQAAAAAElFTkSuQmCC'); background-size: cover; display: block;\"\n    >\n      <img\n        class=\"gatsby-resp-image-image\"\n        style=\"width: 100%; margin: 0; vertical-align: middle; position: absolute; top: 0; left: 0; box-shadow: inset 0px 0px 0px 400px white;\"\n        alt=\"open dbmanager qgis\"\n        title=\"\"\n        src=\"/static/84b4b9eee807dcc379704088f78abd95-44d6a.png\"\n        srcset=\"/static/84b4b9eee807dcc379704088f78abd95-f4799.png 173w,\n/static/84b4b9eee807dcc379704088f78abd95-b3b1d.png 345w,\n/static/84b4b9eee807dcc379704088f78abd95-44d6a.png 690w,\n/static/84b4b9eee807dcc379704088f78abd95-bc0f7.png 1035w,\n/static/84b4b9eee807dcc379704088f78abd95-b50e5.png 1380w,\n/static/84b4b9eee807dcc379704088f78abd95-0ed32.png 2070w,\n/static/84b4b9eee807dcc379704088f78abd95-55f2e.png 2560w\"\n        sizes=\"(max-width: 690px) 100vw, 690px\"\n      />\n    </span>\n  </span>\n  \n  </a>\n    </p>\n<p>then click the down arrow icon and fill the fields with the preferences on how the shapefile has to be imported into a PostGIS table.</p>\n<p>\n  <a\n    class=\"gatsby-resp-image-link\"\n    href=\"undefined\"\n    style=\"display: block\"\n    target=\"_blank\"\n    rel=\"noopener\"\n  >\n  \n  <span\n    class=\"gatsby-resp-image-wrapper\"\n    style=\"position: relative; z-index: -1; display: block; \"\n  >\n    <span\n      class=\"gatsby-resp-image-background-image\"\n      style=\"padding-bottom: 56.09375%;position: relative; width: 100%; bottom: 0; left: 0; background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsSAAALEgHS3X78AAABPUlEQVQoz52S3Y6CMBCFef932tsNWd0ALdYCRUCMIm4W0Rsj6NnO+BPddS+0yZe0087p6UwdHRkkSWIxyLIMuSWbZEhNyhhjEI4UoijCJLWxM3T2EU6e55xUVRVWqxUjtIAUnr0ktskTJOZ0WVmWoPPDcAhRC6hvdYf+0nDK6ZQFm6ZB27YMrYuiuEJC8/kcU3uW5rTf9R2Ox+MdFHPW65ZdbbdbXAa5JXfJ2Xld11eWyyWXqO97/B4Ucw6Hw58NFoxjTiSBW8HFYsH1fFpQjsbQWnPtZrMZcxF9SVDpGJ7nQcqQ6ybkiLsbpQXG+gVBeq7ruvB9/4Tns1tqzEsOdZQgsEJCBIhtPUno8nRaPyVIjQiCAGEYXpFSYjAY4O3dw8en/79g13U8uWWz2bALpdRD6G/u93tQ7i273Q4//HU5ut3b0BQAAAAASUVORK5CYII='); background-size: cover; display: block;\"\n    >\n      <img\n        class=\"gatsby-resp-image-image\"\n        style=\"width: 100%; margin: 0; vertical-align: middle; position: absolute; top: 0; left: 0; box-shadow: inset 0px 0px 0px 400px white;\"\n        alt=\"load shapefile qgis\"\n        title=\"\"\n        src=\"/static/c4172bc6696ee7cc8b50b7e2206b6d51-44d6a.png\"\n        srcset=\"/static/c4172bc6696ee7cc8b50b7e2206b6d51-f4799.png 173w,\n/static/c4172bc6696ee7cc8b50b7e2206b6d51-b3b1d.png 345w,\n/static/c4172bc6696ee7cc8b50b7e2206b6d51-44d6a.png 690w,\n/static/c4172bc6696ee7cc8b50b7e2206b6d51-bc0f7.png 1035w,\n/static/c4172bc6696ee7cc8b50b7e2206b6d51-b50e5.png 1380w,\n/static/c4172bc6696ee7cc8b50b7e2206b6d51-0ed32.png 2070w,\n/static/c4172bc6696ee7cc8b50b7e2206b6d51-55f2e.png 2560w\"\n        sizes=\"(max-width: 690px) 100vw, 690px\"\n      />\n    </span>\n  </span>\n  \n  </a>\n    </p>\n<p>Important notes:</p>\n<ul>\n<li>The name of the final table <code>mzn</code></li>\n<li>The name of the geometry column <code>shape</code></li>\n<li>The reprojection from the source SRID <code>EPSG:32632</code> to <code>EPSG:4326</code> with geographic coordinates</li>\n<li>The setting to create a spatial index for the geometry column</li>\n</ul>",
			"timeToRead": 1,
			"excerpt": "Load the shapefile into PostGIS The first thing to do is to add the dataset   to our PostGIS database  . QGIS is the quick way to go. Let's...",
			"frontmatter": {
				"title": "Load Data",
				"cover": null,
				"date": null,
				"category": null,
				"tags": null
			}
		},
		"tableOfContents": {
			"chapters": [
				{
					"title": "1. Introduction",
					"entries": null,
					"chapters": [
						{
							"title": "1.1 OGC Standards",
							"entries": [
								{
									"entry": {
										"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/intro_ogc.md absPath of file",
										"childMarkdownRemark": {
											"fields": {
												"slug": "/introduction-to-ogc"
											},
											"frontmatter": {
												"title": "Introduction to OGC"
											}
										}
									}
								}
							],
							"chapters": [
								{
									"title": "1.1.1 Web Mapping Service",
									"entries": [
										{
											"entry": {
												"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/intro_wms.md absPath of file",
												"childMarkdownRemark": {
													"fields": {
														"slug": "/introduction-to-wms"
													},
													"frontmatter": {
														"title": "Introduction to WMS"
													}
												}
											}
										},
										{
											"entry": {
												"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/examples_wms.md absPath of file",
												"childMarkdownRemark": {
													"fields": {
														"slug": "/wms-examples"
													},
													"frontmatter": {
														"title": "WMS Examples"
													}
												}
											}
										}
									]
								},
								{
									"title": "1.1.2 Web Feature Service",
									"entries": [
										{
											"entry": {
												"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/intro_wfs.md absPath of file",
												"childMarkdownRemark": {
													"fields": {
														"slug": "/introduction-to-wfs"
													},
													"frontmatter": {
														"title": "Introduction to WFS"
													}
												}
											}
										},
										{
											"entry": {
												"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/examples_wfs.md absPath of file",
												"childMarkdownRemark": {
													"fields": {
														"slug": "/wfs-examples"
													},
													"frontmatter": {
														"title": "WFS Examples"
													}
												}
											}
										}
									]
								},
								{
									"title": "1.1.3 Web Coverage Service",
									"entries": [
										{
											"entry": {
												"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/intro_wcs.md absPath of file",
												"childMarkdownRemark": {
													"fields": {
														"slug": "/introduction-to-wcs"
													},
													"frontmatter": {
														"title": "Introduction to WCS"
													}
												}
											}
										},
										{
											"entry": {
												"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/examples_wcs.md absPath of file",
												"childMarkdownRemark": {
													"fields": {
														"slug": "/wcs-examples"
													},
													"frontmatter": {
														"title": "WCS Examples"
													}
												}
											}
										}
									]
								},
								{
									"title": "1.1.4 Web Processing Service",
									"entries": [
										{
											"entry": {
												"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/intro_wps.md absPath of file",
												"childMarkdownRemark": {
													"fields": {
														"slug": "/introduction-to-wps"
													},
													"frontmatter": {
														"title": "Introduction to WPS"
													}
												}
											}
										},
										{
											"entry": {
												"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/examples_wps.md absPath of file",
												"childMarkdownRemark": {
													"fields": {
														"slug": "/wps-examples"
													},
													"frontmatter": {
														"title": "WPS Examples"
													}
												}
											}
										}
									]
								}
							]
						},
						{
							"title": "1.2 CAAML",
							"entries": [
								{
									"entry": {
										"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/intro_caaml.md absPath of file",
										"childMarkdownRemark": {
											"fields": {
												"slug": "/introduction-to-caaml"
											},
											"frontmatter": {
												"title": "Introduction to CAAML"
											}
										}
									}
								}
							],
							"chapters": null
						},
						{
							"title": "1.3 INSPIRE",
							"entries": [
								{
									"entry": {
										"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/intro_inspire.md absPath of file",
										"childMarkdownRemark": {
											"fields": {
												"slug": "/introduction-to-inspire"
											},
											"frontmatter": {
												"title": "Introduction to INSPIRE"
											}
										}
									}
								}
							],
							"chapters": null
						}
					]
				},
				{
					"title": "2. Standards in action",
					"entries": null,
					"chapters": [
						{
							"title": "2.1 Prepare data and toolkit",
							"entries": [
								{
									"entry": {
										"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/intro_data_tools.md absPath of file",
										"childMarkdownRemark": {
											"fields": {
												"slug": "/data-and-geospatial-tools"
											},
											"frontmatter": {
												"title": "Data and geospatial tools"
											}
										}
									}
								},
								{
									"entry": {
										"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/bootstrap_servers.md absPath of file",
										"childMarkdownRemark": {
											"fields": {
												"slug": "/start-the-environment"
											},
											"frontmatter": {
												"title": "Start the environment"
											}
										}
									}
								}
							],
							"chapters": [
								{
									"title": "2.1.1 Manage the data",
									"entries": [
										{
											"entry": {
												"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/load_data.md absPath of file",
												"childMarkdownRemark": {
													"fields": {
														"slug": "/load-data"
													},
													"frontmatter": {
														"title": "Load Data"
													}
												}
											}
										},
										{
											"entry": {
												"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/clean_data.md absPath of file",
												"childMarkdownRemark": {
													"fields": {
														"slug": "/clean-data"
													},
													"frontmatter": {
														"title": "Clean Data"
													}
												}
											}
										}
									]
								},
								{
									"title": "2.1.2 Design the CAAML schema",
									"entries": [
										{
											"entry": {
												"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/er_design.md absPath of file",
												"childMarkdownRemark": {
													"fields": {
														"slug": "/caaml-model-design"
													},
													"frontmatter": {
														"title": "CAAML model design"
													}
												}
											}
										},
										{
											"entry": {
												"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/populate_data.md absPath of file",
												"childMarkdownRemark": {
													"fields": {
														"slug": "/populate-region"
													},
													"frontmatter": {
														"title": "Populate Region"
													}
												}
											}
										}
									]
								}
							]
						},
						{
							"title": "2.2 Build CAAML with GeoAvalanche",
							"entries": [
								{
									"entry": {
										"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/caaml_hale.md absPath of file",
										"childMarkdownRemark": {
											"fields": {
												"slug": "/configure-the-application-schema-for-caaml"
											},
											"frontmatter": {
												"title": "Configure the application schema for CAAML"
											}
										}
									}
								},
								{
									"entry": {
										"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/load_configuration.md absPath of file",
										"childMarkdownRemark": {
											"fields": {
												"slug": "/push-the-configuration-to-geo-avalanche"
											},
											"frontmatter": {
												"title": "Push the configuration to GeoAvalanche"
											}
										}
									}
								},
								{
									"entry": {
										"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/query_data.md absPath of file",
										"childMarkdownRemark": {
											"fields": {
												"slug": "/query-our-region-features"
											},
											"frontmatter": {
												"title": "Query our Region features"
											}
										}
									}
								}
							],
							"chapters": null
						}
					]
				},
				{
					"title": "3. Main Chapter",
					"entries": [
						{
							"entry": {
								"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/lesson_six.md absPath of file",
								"childMarkdownRemark": {
									"fields": {
										"slug": "/lesson-six"
									},
									"frontmatter": {
										"title": "Lesson Six"
									}
								}
							}
						}
					],
					"chapters": null
				}
			]
		}
	},
	"pathContext": {
		"slug": "/load-data"
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/load-data.json
// module id = 419
// module chunks = 277964865062957